import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

export default function useSuccessSnackbar() {

  const successSnackbar = (message: string) => {
    dispatch(
      openSnackbar({
        open: true,
        message: message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: false
      })
    );
  };

  return successSnackbar;
}
